export const PUSH_SCENARIO_OPTIONS = [
  { value: 'MANUAL_BROADCAST', label: 'Manual broadcast' },
  { value: 'ABSENCE_NOTIFICATION', label: 'Absence notification' },
  { value: 'WAITLIST_CONFIRMATION', label: 'Waitlist confirmation' },
  { value: 'DROP_CLASS', label: 'Class drop' },
  { value: 'CLASS_TRANSFER', label: 'Class transfer' },
  { value: 'RECITAL_PUBLISHED', label: 'Recital published' },
  { value: 'PAYMENT_SUCCESS', label: 'Payment success' },
  { value: 'PAYMENT_FAILURE', label: 'Payment failure' },
  { value: 'TRIAL_CONFIRMED', label: 'Trial confirmed' },
  { value: 'TRIAL_REMINDER', label: 'Trial reminder (24h)' },
  { value: 'SCHEDULED_DROP_WARNING', label: 'Scheduled drop warning' },
  { value: 'SESSION_REGISTRATION_OPEN', label: 'Session registration open' },
  { value: 'CLASS_SCHEDULE_CHANGE', label: 'Class schedule change' },
] as const;

export const PUSH_STATUS_OPTIONS = [
  { value: 'sent', label: 'Sent' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'handoff', label: 'Composer handoff' },
  { value: 'skipped', label: 'Skipped' },
  { value: 'failed', label: 'Failed' },
] as const;

export function formatPushScenarioLabel(scenario: string): string {
  return (
    PUSH_SCENARIO_OPTIONS.find((option) => option.value === scenario)?.label ??
    scenario
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/^\w/, (character) => character.toUpperCase())
  );
}

export function formatPushStatusLabel(status: string): string {
  return (
    PUSH_STATUS_OPTIONS.find((option) => option.value === status)?.label ??
    status.replace(/_/g, ' ')
  );
}

export function pushStatusBadgeVariant(
  status: string,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (status === 'sent') return 'secondary';
  if (status === 'scheduled') return 'default';
  if (status === 'handoff') return 'outline';
  if (status === 'failed') return 'destructive';
  return 'outline';
}

export function formatPushModeLabel(mode: string): string {
  switch (mode) {
    case 'send':
      return 'Immediate send';
    case 'schedule':
      return 'Scheduled';
    case 'dashboard':
      return 'MI composer';
    default:
      return mode;
  }
}
